import * as React from 'react';
import { getFocusableChildren, bindKeypress } from '../../helpers/window-helpers';
import { Html } from '../../helpers/html-helpers';

export interface IPromptModalProps {
    title: string;
    message: string;
    cancelString?: string;
    confirmString?: string;
    confirmFunction?: any;
    cancelFunction?: any;
    isError?: boolean;
}

class PromptModal extends React.Component<IPromptModalProps, any> {
    render() {
        return (
            <section role="dialog" aria-labelledby="modal-title" className="modal-container" id="modal-container">
                <div role="document">

                    <div className="modal-content">
                        <h3 className="heading-general" id="modal-title">{this.props.title}</h3>
                        {
                            Html.renderParagraph(this.props.message, (this.props.isError ? "promo-code-conflict-error" : ""))
                        }
                    </div>

                    <div className="modal-cta-container">
                        {/* Only show the cancel or ok button if they have a function associated with it. */}
                        {this.props.cancelFunction ? <button className="dialog-cta-btn" type="button" onClick={() => { this.props.cancelFunction() }}>{this.props.cancelString ? this.props.cancelString : "Cancel"}</button> : null}

                        {this.props.confirmFunction ? <button className="dialog-cta-btn" type="button" onClick={() => { this.props.confirmFunction() }}>{this.props.confirmString ? this.props.confirmString : "Ok"}</button> : null}
                    </div>
                </div>
            </section>
        );
    }
}

export default PromptModal;